import { render, staticRenderFns } from "./StepDelivery.vue?vue&type=template&id=2aca86de&scoped=true"
import script from "./StepDelivery.vue?vue&type=script&lang=js"
export * from "./StepDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca86de",
  null
  
)

export default component.exports